import React, { Component } from 'react';
import { withRouter } from 'react-router';

import CustomSurveyQuestionApi from 'apis/questions/CustomSurveyQuestion';
import InputTypesApi from 'apis/questions/InputTypes';
import QuestionForm from 'components/questions/form/questionForm'

import 'assets/scss/components/npsScale.css';

class AddNewQuestion extends Component {
  constructor() {
    super();
    this.state = {
      currentStep: 0,
      inputType: null,
      toggleSuggestions: false,
      suggestedQuestions: [],
      timer: null,
      inputTypes: [],
      question: {
        answer_attributes: [],
      },
    };
  }

  componentDidMount() {
    this.fetchInputTypes();
  }

  componentWillUnmount() {
    const { timer } = this.state;
    clearTimeout(this.state.timer);
  }

  fetchInputTypes = async () => {
    try {
      const { data: inputTypes } = await InputTypesApi.fetchInputTypes();
      this.setState({ inputTypes });
    } catch (e) {
      console.log(e);
    }
  };

  handleNext = () => {
    this.setState({ currentStep: 1 });
  };

  handleSubmit = values => {
    const { inputType } = this.state;
    const { addQuestion } = this.props;
    const { question, answer_attributes, survey_template_question_id } = values;
    const answerAttributes = answer_attributes.map(answer => {
      delete answer.id;
      delete answer.editAnswer;
      delete answer.edit;
      return answer;
    });

    const questionObj = {
      answer_attributes: answerAttributes,
      question,
      survey_template_question_id,
      input_type_id: inputType.id,
    };

    addQuestion(questionObj);
  };

  setInputType = value => {
    const { inputType, question } = this.state;
    if (value && inputType !== value) {
      return this.setState({
        inputType: value,
        question: {
          ...question,
          answer_attributes: [],
        },
      });
    }

    this.setState({ inputType: value });
  };

  handleSuggestionSelected = selectedQuestion => {
    const {
      question,
      answers,
      input_type: inputType,
      survey_template_question_id,
    } = selectedQuestion;
    const newQuestion = {
      question,
      answer_attributes: answers.map(answer => ({
        ...answer,
        editAnswer: answer.answer,
      })),
      survey_template_question_id,
    };

    this.setState({
      inputType: inputType,
      question: newQuestion,
      currentStep: 1,
      suggestedQuestions: [],
      toggleSuggestions: false,
    });
  };

  fetchSuggestedQuestions = value => {
    const { surveyTemplate, match } = this.props;
    if (surveyTemplate) return;

    const { timer } = this.state;
    const { customSurveyId, id: businessId } = match.params;

    clearTimeout(timer);
    if (!value) {
      this.setState({ suggestedQuestions: [] });
      return;
    }

    const newTimer = setTimeout(() => {
      CustomSurveyQuestionApi.getSuggestions({
        query: value,
        custom_survey_id: customSurveyId,
        business_id: businessId,
      })
        .then(({ data }) => {
          this.setState({ suggestedQuestions: data });
        })
        .catch(console.log);
    }, 300);
    this.setState({ timer: newTimer });
  };

  render() {
    const { addQuestionVisible, toggleAddQuestion } = this.props;
    const {
      inputType,
      currentStep,
      suggestedQuestions,
      question,
      inputTypes,
    } = this.state;

    if (!addQuestionVisible) return null;

    return (
      <QuestionForm
        inputType={inputType}
        question={question}
        currentStep={currentStep}
        toggleForm={toggleAddQuestion}
        suggestedQuestions={suggestedQuestions}
        inputTypes={inputTypes}
        handleSubmit={this.handleSubmit}
        handleNext={this.handleNext}
        fetchSuggestedQuestions={this.fetchSuggestedQuestions}
        handleSuggestionSelected={this.handleSuggestionSelected}
        setInputType={this.setInputType}
      />
    );
  }
}

export default withRouter(AddNewQuestion);



// WEBPACK FOOTER //
// ./src/components/customSurvey/questions/addNewQuestion.js